var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.25A6.74 6.74 0 0 0 3.25 10 6.74 6.74 0 0 0 10 16.75 6.74 6.74 0 0 0 16.75 10 6.74 6.74 0 0 0 10 3.25zM1.75 10A8.24 8.24 0 0 1 10 1.75 8.24 8.24 0 0 1 18.25 10 8.24 8.24 0 0 1 10 18.25 8.24 8.24 0 0 1 1.75 10z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.408 8.93.242 5h-1.4l.192-5h.966z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 6.82a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0z",
    fill: "currentColor"
  })));
};
export default SvgInfo;